"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.xxxLargeVariables = exports.xxxLarge = exports.xxLargeVariables = exports.xxLarge = exports.xSmallVariables = exports.xSmall = exports.xLargeVariables = exports.xLarge = exports.smallVariables = exports.small = exports.mediumVariables = exports.medium = exports.largeVariables = exports.large = void 0;
require("./scale.css");
/**
 * DO NOT MODIFY
 * Generated from scripts/codegen/main.ts
 */

const sharedVariables = {
  '--display1-font-weight': '400',
  '--display1-font-family': 'var(--cds-font-display)',
  '--display2-font-weight': '400',
  '--display2-font-family': 'var(--cds-font-display)',
  '--display3-font-weight': '400',
  '--display3-font-family': 'var(--cds-font-display)',
  '--title1-font-weight': '600',
  '--title1-font-family': 'var(--cds-font-display)',
  '--title2-font-weight': '400',
  '--title2-font-family': 'var(--cds-font-display)',
  '--title3-font-weight': '600',
  '--title4-font-weight': '400',
  '--headline-font-weight': '600',
  '--headline-font-family': 'var(--cds-font-sans)',
  '--body-font-weight': '400',
  '--body-font-family': 'var(--cds-font-sans)',
  '--label1-font-weight': '600',
  '--label2-font-weight': '400',
  '--caption-font-weight': '600',
  '--legal-font-weight': '400',
  '--spacing-0': '0px',
  '--spacing-0\\.5': '4px',
  '--spacing-1': '8px'
};
const sharedDenseVariables = {
  '--title3-line-height': '24px',
  '--title3-font-family': 'var(--cds-font-sans)',
  '--title4-line-height': '24px',
  '--title4-font-family': 'var(--cds-font-sans)',
  '--headline-line-height': '20px',
  '--body-line-height': '20px',
  '--label1-line-height': '16px',
  '--label1-font-family': 'var(--cds-font-text)',
  '--label2-line-height': '16px',
  '--label2-font-family': 'var(--cds-font-text)',
  '--caption-font-family': 'var(--cds-font-text)',
  '--legal-font-family': 'var(--cds-font-text)',
  '--spacing-1\\.5': '10px',
  '--spacing-2': '12px',
  '--spacing-3': '16px',
  '--spacing-4': '20px',
  '--spacing-5': '24px',
  '--spacing-6': '28px',
  '--spacing-7': '32px',
  '--spacing-8': '36px',
  '--spacing-9': '40px',
  '--spacing-10': '44px',
  '--checkbox-size': '16px',
  '--radio-size': '16px',
  '--switch-width': '42px',
  '--switch-height': '24px',
  '--switch-thumb-size': '22px'
};
const sharedNormalVariables = {
  '--label1-font-family': 'var(--cds-font-sans)',
  '--label2-font-family': 'var(--cds-font-sans)',
  '--spacing-1\\.5': '12px',
  '--spacing-2': '16px',
  '--spacing-3': '24px',
  '--spacing-4': '32px',
  '--spacing-5': '40px',
  '--spacing-6': '48px',
  '--spacing-7': '56px',
  '--spacing-8': '64px',
  '--spacing-9': '72px',
  '--spacing-10': '80px',
  '--checkbox-size': '20px',
  '--radio-size': '20px',
  '--switch-width': '52px',
  '--switch-height': '32px',
  '--switch-thumb-size': '30px'
};
const xSmallVariables = Object.assign({}, sharedVariables, sharedDenseVariables, {
  '--display1-font-size': '61px',
  '--display1-line-height': '68px',
  '--display2-font-size': '45px',
  '--display2-line-height': '52px',
  '--display3-font-size': '37px',
  '--display3-line-height': '44px',
  '--title1-font-size': '25px',
  '--title1-line-height': '32px',
  '--title2-font-size': '25px',
  '--title2-line-height': '32px',
  '--title3-font-size': '17px',
  '--title4-font-size': '17px',
  '--headline-font-size': '14px',
  '--body-font-size': '14px',
  '--label1-font-size': '11px',
  '--label2-font-size': '11px',
  '--caption-font-size': '10px',
  '--caption-line-height': '12px',
  '--legal-font-size': '10px',
  '--legal-line-height': '12px'
});
exports.xSmallVariables = xSmallVariables;
const smallVariables = Object.assign({}, sharedVariables, sharedDenseVariables, {
  '--display1-font-size': '62px',
  '--display1-line-height': '72px',
  '--display2-font-size': '46px',
  '--display2-line-height': '56px',
  '--display3-font-size': '38px',
  '--display3-line-height': '48px',
  '--title1-font-size': '26px',
  '--title1-line-height': '32px',
  '--title2-font-size': '26px',
  '--title2-line-height': '32px',
  '--title3-font-size': '18px',
  '--title4-font-size': '18px',
  '--headline-font-size': '14px',
  '--body-font-size': '14px',
  '--label1-font-size': '12px',
  '--label2-font-size': '12px',
  '--caption-font-size': '11px',
  '--caption-line-height': '16px',
  '--legal-font-size': '11px',
  '--legal-line-height': '16px'
});
exports.smallVariables = smallVariables;
const mediumVariables = Object.assign({}, sharedVariables, sharedDenseVariables, {
  '--display1-font-size': '63px',
  '--display1-line-height': '72px',
  '--display2-font-size': '47px',
  '--display2-line-height': '56px',
  '--display3-font-size': '39px',
  '--display3-line-height': '48px',
  '--title1-font-size': '27px',
  '--title1-line-height': '36px',
  '--title2-font-size': '27px',
  '--title2-line-height': '36px',
  '--title3-font-size': '19px',
  '--title4-font-size': '19px',
  '--headline-font-size': '15px',
  '--body-font-size': '15px',
  '--label1-font-size': '13px',
  '--label2-font-size': '13px',
  '--caption-font-size': '12px',
  '--caption-line-height': '16px',
  '--legal-font-size': '12px',
  '--legal-line-height': '16px'
});
exports.mediumVariables = mediumVariables;
const largeVariables = Object.assign({}, sharedVariables, sharedNormalVariables, {
  '--display1-font-size': '64px',
  '--display1-line-height': '72px',
  '--display2-font-size': '48px',
  '--display2-line-height': '56px',
  '--display3-font-size': '40px',
  '--display3-line-height': '48px',
  '--title1-font-size': '28px',
  '--title1-line-height': '36px',
  '--title2-font-size': '28px',
  '--title2-line-height': '36px',
  '--title3-font-size': '20px',
  '--title3-line-height': '28px',
  '--title3-font-family': 'var(--cds-font-sans)',
  '--title4-font-size': '20px',
  '--title4-line-height': '28px',
  '--title4-font-family': 'var(--cds-font-sans)',
  '--headline-font-size': '16px',
  '--headline-line-height': '24px',
  '--body-font-size': '16px',
  '--body-line-height': '24px',
  '--label1-font-size': '14px',
  '--label1-line-height': '20px',
  '--label2-font-size': '14px',
  '--label2-line-height': '20px',
  '--caption-font-size': '13px',
  '--caption-line-height': '16px',
  '--caption-font-family': 'var(--cds-font-text)',
  '--legal-font-size': '13px',
  '--legal-line-height': '16px',
  '--legal-font-family': 'var(--cds-font-text)'
});
exports.largeVariables = largeVariables;
const xLargeVariables = Object.assign({}, sharedVariables, sharedNormalVariables, {
  '--display1-font-size': '66px',
  '--display1-line-height': '76px',
  '--display2-font-size': '50px',
  '--display2-line-height': '60px',
  '--display3-font-size': '42px',
  '--display3-line-height': '52px',
  '--title1-font-size': '30px',
  '--title1-line-height': '36px',
  '--title2-font-size': '30px',
  '--title2-line-height': '36px',
  '--title3-font-size': '22px',
  '--title3-line-height': '28px',
  '--title3-font-family': 'var(--cds-font-sans)',
  '--title4-font-size': '22px',
  '--title4-line-height': '28px',
  '--title4-font-family': 'var(--cds-font-sans)',
  '--headline-font-size': '18px',
  '--headline-line-height': '24px',
  '--body-font-size': '18px',
  '--body-line-height': '24px',
  '--label1-font-size': '16px',
  '--label1-line-height': '20px',
  '--label2-font-size': '16px',
  '--label2-line-height': '20px',
  '--caption-font-size': '15px',
  '--caption-line-height': '20px',
  '--caption-font-family': 'var(--cds-font-sans)',
  '--legal-font-size': '15px',
  '--legal-line-height': '20px',
  '--legal-font-family': 'var(--cds-font-sans)'
});
exports.xLargeVariables = xLargeVariables;
const xxLargeVariables = Object.assign({}, sharedVariables, sharedNormalVariables, {
  '--display1-font-size': '68px',
  '--display1-line-height': '76px',
  '--display2-font-size': '52px',
  '--display2-line-height': '60px',
  '--display3-font-size': '44px',
  '--display3-line-height': '52px',
  '--title1-font-size': '32px',
  '--title1-line-height': '40px',
  '--title2-font-size': '32px',
  '--title2-line-height': '40px',
  '--title3-font-size': '24px',
  '--title3-line-height': '32px',
  '--title3-font-family': 'var(--cds-font-sans)',
  '--title4-font-size': '24px',
  '--title4-line-height': '32px',
  '--title4-font-family': 'var(--cds-font-sans)',
  '--headline-font-size': '20px',
  '--headline-line-height': '28px',
  '--body-font-size': '20px',
  '--body-line-height': '28px',
  '--label1-font-size': '18px',
  '--label1-line-height': '24px',
  '--label2-font-size': '18px',
  '--label2-line-height': '24px',
  '--caption-font-size': '17px',
  '--caption-line-height': '20px',
  '--caption-font-family': 'var(--cds-font-sans)',
  '--legal-font-size': '17px',
  '--legal-line-height': '20px',
  '--legal-font-family': 'var(--cds-font-sans)'
});
exports.xxLargeVariables = xxLargeVariables;
const xxxLargeVariables = Object.assign({}, sharedVariables, sharedNormalVariables, {
  '--display1-font-size': '70px',
  '--display1-line-height': '80px',
  '--display2-font-size': '54px',
  '--display2-line-height': '64px',
  '--display3-font-size': '46px',
  '--display3-line-height': '56px',
  '--title1-font-size': '34px',
  '--title1-line-height': '40px',
  '--title2-font-size': '34px',
  '--title2-line-height': '40px',
  '--title3-font-size': '26px',
  '--title3-line-height': '32px',
  '--title3-font-family': 'var(--cds-font-display)',
  '--title4-font-size': '26px',
  '--title4-line-height': '32px',
  '--title4-font-family': 'var(--cds-font-display)',
  '--headline-font-size': '22px',
  '--headline-line-height': '28px',
  '--body-font-size': '22px',
  '--body-line-height': '28px',
  '--label1-font-size': '20px',
  '--label1-line-height': '24px',
  '--label2-font-size': '20px',
  '--label2-line-height': '24px',
  '--caption-font-size': '19px',
  '--caption-line-height': '24px',
  '--caption-font-family': 'var(--cds-font-sans)',
  '--legal-font-size': '19px',
  '--legal-line-height': '24px',
  '--legal-font-family': 'var(--cds-font-sans)'
});
exports.xxxLargeVariables = xxxLargeVariables;
const xSmall = "cds-xSmall-x155bs6r";
exports.xSmall = xSmall;
const small = "cds-small-s1blhwa6";
exports.small = small;
const medium = "cds-medium-m41nt2r";
exports.medium = medium;
const large = "cds-large-llfbhh8";
exports.large = large;
const xLarge = "cds-xLarge-x8sd419";
exports.xLarge = xLarge;
const xxLarge = "cds-xxLarge-x4qb4rx";
exports.xxLarge = xxLarge;
const xxxLarge = "cds-xxxLarge-x1l12f6q";
exports.xxxLarge = xxxLarge;